import { apiAddBraintreeCustomer } from "Root/api/apiCheckout";
import { setCardData } from "Root/checkout/redux/slices/checkoutBillingSlice";
import { fetchShippingData, setShippingInfo } from "Root/checkout/redux/slices/checkoutShippingSlice";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import toastService from "Root/profile/toastService";
import { useDispatch, useSelector } from "react-redux";
import useCheckoutConfirmShipping from "../CheckoutConfirmShipping/useCheckoutConfirmShipping";
import { formatPrice } from "../CheckoutOrderSummary/useCheckoutOrderSummary";
const useCheckoutExpress = () => {
    const dispatch = useDispatch();
    const userCart = useSelector((state) => state.checkoutUserCart.userCart);
    const { subscription, otb, plan } = useSelector((state) => state.checkoutPricing);
    const shippingMethodsData = useSelector((state) => state.checkoutShipping.shippingMethodsData);
    const componentState = useSelector((state) => state.checkoutComponent);
    const { submitAddress } = useCheckoutConfirmShipping(false);
    const getStripeExpressProps = () => {
        const priceOfShipping = plan === "otb" ? otb.shipping : subscription.shipping;
        const priceOfTax = plan === "otb" ? otb.tax_fees : subscription.tax_fees;
        const priceOfTotal = plan === "otb" ? otb.total : subscription.total;
        const duty = plan === "otb" ? otb.duty : subscription.duty;
        const stripeDisplayItems = [
            { label: "Shipping", amount: Math.round(priceOfShipping) },
            { label: "Taxes & Fees", amount: Math.round(priceOfTax) },
            { label: "Subtotal", amount: Math.round(priceOfTotal) },
            { label: "Duty", amount: Math.round(duty) },
        ];
        return {
            shippingPrice: priceOfShipping,
            tax: priceOfTax,
            totalAmount: priceOfTotal,
            stripeDisplayItems,
            setShippingAddress: (data) => { },
            shippingOptions: [
                {
                    id: "standard",
                    label: "Standard shipping",
                    detail: "Arrives in 4 to 7 business days",
                    amount: shippingMethodsData.standard_shipping_price,
                },
                // {
                //   id: "expedited",
                //   label: "Expedited shipping",
                //   detail: "2 Business Days",
                //   amount: shippingMethodsData.expedited_shipping_price,
                // },
            ],
            isGuest: componentState.checkoutSegment === "guest",
        };
    };
    const addBraintreeCustomer = (info) => {
        try {
            apiAddBraintreeCustomer(info);
        }
        catch (err) {
            toastService.errorMessage("Something went wrong");
        }
    };
    const setPaypalData = async (data) => {
        dispatch(setGlobalLoading(true));
        const paypalShippingAddress = data.shipAddress;
        addBraintreeCustomer(data);
        const fname = paypalShippingAddress.recipientName.split(" ")[0];
        const lname = paypalShippingAddress.recipientName.split(" ").slice(1).join(" ");
        const { city, state, postalCode, countryCode, line1, line2 } = paypalShippingAddress;
        const body = {
            firstName: fname,
            lastName: lname,
            street: line1,
            apartment: line2 || "",
            city,
            state,
            zip: postalCode,
            country: countryCode,
            shipping_method: "standard",
        };
        dispatch(setShippingInfo(body));
        await submitAddress(true, false, body);
        dispatch(setCardData({ brand: "Paypal", isPaypal: true }));
        await dispatch(fetchShippingData());
        dispatch(setGlobalLoading(false));
    };
    const setLoading = (value) => {
        dispatch(setGlobalLoading(value));
    };
    return {
        setLoading,
        userCart,
        setPaypalData,
        total: plan === "subscription" ? formatPrice(subscription.total) : formatPrice(otb.total),
        deliveryFreq: subscription.delivery_frequency,
        recurringPrice: formatPrice(subscription.total),
        getStripeExpressProps,
    };
};
export default useCheckoutExpress;
